import { TableCell as Cell } from "@mui/material";

const TableCell = ({style, children}: any) => <Cell sx={{whiteSpace: 'nowrap'}} style={style}>{children || '-'}</Cell>

export default TableCell;